export default "__VITE_PUBLIC_ASSET__99b35d01__"